import { TextField, Grid } from '@mui/material';
import LocationMapPigeon2 from './LocationMapPigeon2';
import { PlaceFormData } from '@/hooks/usePlaceForm';

interface CoordinateInputProps {
  coordinates: { latitude: string; longitude: string };
  onChange: (field: 'latitude' | 'longitude', value: string) => void;
  onMapClick?: (coordinates: { latitude: number; longitude: number }) => void;
}

export const CoordinateInput = ({ coordinates, onChange, onMapClick }: CoordinateInputProps) => {
  const selectedCoordinates = {
    latitude: parseFloat(coordinates.latitude) || 0,
    longitude: parseFloat(coordinates.longitude) || 0,
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ minHeight: '40vh', maxHeight: '50vh' }}>
        <LocationMapPigeon2
          places={[]}
          onMarkerClick={(place) => {
            if (onMapClick) {
              onMapClick({
                latitude: place.coordinates.latitude,
                longitude: place.coordinates.longitude,
              });
            }
          }}
          center={[selectedCoordinates.latitude, selectedCoordinates.longitude]}
          createPlaceMode={true}
          onMapClick={(coords) => {
            if (onMapClick) {
              onMapClick(coords);
            }
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Latitude"
          name="latitude"
          value={coordinates.latitude}
          onChange={(e) => onChange('latitude', e.target.value)}
          fullWidth
          required
          margin="normal"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Longitude"
          name="longitude"
          value={coordinates.longitude}
          onChange={(e) => onChange('longitude', e.target.value)}
          fullWidth
          required
          margin="normal"
        />
      </Grid>
    </Grid>
  );
};
